module.exports = __webpack_public_path__ + "img/1.df998b93.png";